import { snapshot } from 'valtio'

import { mapSelectionAtom } from '../mapSelection'

export const getConnectedList = () => {
  return snapshot(mapSelectionAtom.connectedList)
}
